import { render } from "./MySelect.vue?vue&type=template&id=3cb99fa5&scoped=true"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import "./MySelect.vue?vue&type=style&index=0&id=3cb99fa5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cb99fa5"

export default script